/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileViewDetails = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M5 2H4v20h6v-2H6V4h7v5h5v4h2V7.586l-.293-.293-5-5L14.414 2H5zm11.586 5H15V5.414L16.586 7zm6.308 11.553C21.736 16.236 19.654 15 17.5 15c-2.153 0-4.236 1.236-5.394 3.553l-.224.447.224.447C13.264 21.764 15.346 23 17.5 23c2.153 0 4.236-1.236 5.394-3.553l.224-.447-.224-.447zM17.5 21c-1.221 0-2.5-.628-3.355-2 .855-1.372 2.134-2 3.355-2s2.5.628 3.355 2c-.855 1.372-2.134 2-3.355 2zm0-.75a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileViewDetails as FileViewDetails };
